export enum actionTypes {
  ESTADOS_ESTUDIO_FETCH = 'ESTADOS_ESTUDIO_FETCH',
  ESTADOS_ESTUDIO_SUCCESS = 'ESTADOS_ESTUDIO_SUCCESS',
  ESTADOS_ESTUDIO_ERROR = 'ESTADOS_ESTUDIO_ERROR',
  ESTADOS_ESTUDIO_RESET = 'ESTADOS_ESTUDIO_RESET',
}

export enum EstadosEstudioStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface EstadoEstudio {
  id: number
  nombre: string
}

export interface EstadosEstudioState {
  status: EstadosEstudioStatus
  estadosEstudio: Array<EstadoEstudio>
}

export interface EstadosEstudioFetch {
  type: typeof actionTypes.ESTADOS_ESTUDIO_FETCH
  payload: null
}

export interface EstadosEstudioSuccess {
  type: typeof actionTypes.ESTADOS_ESTUDIO_SUCCESS
  payload: { estadosEstudio }
}

export interface EstadosEstudioError {
  type: typeof actionTypes.ESTADOS_ESTUDIO_ERROR
  payload: null
}

export interface EstadosEstudioReset {
  type: typeof actionTypes.ESTADOS_ESTUDIO_RESET
  payload: null
}

export type EstadosEstudioActions =
  | EstadosEstudioFetch
  | EstadosEstudioSuccess
  | EstadosEstudioError
  | EstadosEstudioReset

export const initialState: EstadosEstudioState = {
  status: EstadosEstudioStatus.Idle,
  estadosEstudio: [],
}
